export const en = {
    active: 'Data collection in progress.',
    'active-grid': 'Gathering data',
    'and-grid': 'and',
    'budget-grid': 'budget',
    completed: 'Survey complete.',
    'completed-grid': 'Done',
    'coverage-grid': 'coverage',
    draft: 'Draft.',
    'draft-grid': 'Draft',
    'low-grid': 'insufficient {reason}',
    moderation: 'Submitted for moderation.',
    'moderation-grid': 'Under moderation',
    'not-brand-grid': 'brand is not clear',
    reject: 'The survey did not pass moderation.',
    'reject-grid': 'Rejected by moderation',
    'show-params-grid': 'view parameters',
    'show-result-grid': 'results available',
    stop: 'The survey has been stopped.',
    'stop-grid': 'Stopped'
};
